/**
 * @file index.tsx
 *
 * @fileoverview Renders blog search banner image.
 */

import { Image as ImageType } from '~/jobiqo/types/types';
import Image from '~/jobiqo/components/Image';
import styles from './blogSearchBanner.module.scss';

interface BlogSearchBannerProps {
  /**
   * The banner image.
   */
  image: ImageType;
}

export default function BlogSearchBanner({
  image: { alt, title, url, caption },
}: BlogSearchBannerProps) {
  return (
    <div className={styles.banner}>
      <span className={styles.bannerOverlay} />
      <Image
        width={null}
        height={null}
        src={url}
        alt={alt ?? ''}
        {...(title && { title })}
        priority={true}
      />
      {caption && <span className={styles.bannerCaption}>{caption}</span>}
    </div>
  );
}
